import React from 'react';
import { Image } from 'react-bootstrap';

interface LogoProps {
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ className }) => {
  const defaultClassName = process.env.REACT_APP_LOGO || 'img-logo-spd-old';
  const combinedClassName = className
    ? `${className} ${defaultClassName}`
    : defaultClassName;

  return <Image className={combinedClassName} alt="Logo SPD" />;
};

export default Logo;
